const INVALID_REQUEST_URL = "INVALID_REQUEST_URL";
const MESSAGE = "Request blocked: URL contains a missing or invalid parameter.";

const isPlaceholder = (value) => /^(?:undefined|null)$/i.test(value.trim());

export const isValidUrlParameter = (value) =>
  (typeof value === "string" || typeof value === "number") &&
  String(value).trim() !== "" &&
  !isPlaceholder(String(value)) &&
  (typeof value !== "number" || Number.isFinite(value));

const hasInvalidUrlValue = (url) => {
  if (typeof url !== "string" || !url.trim()) return true;
  const parsed = new URL(url, "https://request.invalid");
  return (
    isPlaceholder(parsed.hostname) ||
    parsed.pathname
      .split("/")
      .some((part) => isPlaceholder(decodeURIComponent(part))) ||
    Array.from(parsed.searchParams.values()).some(isPlaceholder)
  );
};

export const createInvalidRequestUrlError = (message = MESSAGE) => ({
  status: "CUSTOM_ERROR",
  error: message,
  data: { error: INVALID_REQUEST_URL, message },
});

export const getRequestUrlError = (url, baseUrl) => {
  let invalid;
  try {
    invalid =
      hasInvalidUrlValue(url) ||
      (baseUrl !== undefined && hasInvalidUrlValue(baseUrl));
  } catch (error) {
    if (!(error instanceof URIError) && !(error instanceof TypeError))
      throw error;
    invalid = true;
  }
  if (!invalid) return null;
  return createInvalidRequestUrlError();
};

export const assertValidRequestUrl = (url, baseUrl) => {
  const failure = getRequestUrlError(url, baseUrl);
  if (!failure) return;
  console.error(failure.error);
  const error = new Error(failure.error);
  error.code = failure.data.error;
  throw error;
};
